//React
import React from "react";
import {
  NavLink,
} from "react-router-dom";


//Icon
import SearchIcon from '@material-ui/icons/Search';
import PetsIcon from '@material-ui/icons/Pets';
import StarRoundedIcon from '@material-ui/icons/Star';


class Comp extends React.Component {
  render() {
    return (
      <div className='sub_menu'>
        <div className='outer'>
            <NavLink to="/search/" exact className='link' activeClassName="selected">
                <SearchIcon className='icon'/><div className='text'>会員検索</div>
            </NavLink>
            <NavLink
              to="/footprint/partner/"
              isActive={
                (match, location) => {
                  var regex = new RegExp(/footprint/);
                  if (regex.test(location.pathname)) {
                    return true;
                  }
                }
              }
              className='link'
              activeClassName="selected"
            >
              <PetsIcon className='icon' /><div className='text'>足あと</div>
            </NavLink>
            <NavLink
              to="/favorite/my/"
              isActive={
                (match, location) => {
                  var regex = new RegExp(/favorite/);
                  if (regex.test(location.pathname)) {
                    return true;
                  }
                }
              }
              className='link'
              activeClassName="selected"
            >
              <StarRoundedIcon className='icon' /><div className='text'>お気に入り</div>
            </NavLink>
        </div>
      </div>
    )
  }
}

export default Comp;
